import React from "react";
import styles from "./Avatar.module.css";
import ProfilePic from "../../../assets/profilePic.jpg";

export default function Avatar() {
	const handleLogoClick = () => {
		window.location.href = "https://cudy.co";
	};

	return (
		<div className={styles.avatar}>
			<img
				className={styles.avatarImage}
				src={ProfilePic}
				alt=""
				onClick={handleLogoClick}
			/>
		</div>
	);
}
